import { useEffect, useState } from "react";
import {
  bankAccountOptions,
  typeBankAccountOptions,
} from "../../utils/options_selects";
import { sanitizarInputNumerico } from "../../utils/validateData";
import FilterableSelect from "../new_components/FilterableSelect";
import StepInput from "../new_components/StepInput";

export function FormBankAccount({
  _state = {
    bankAccount: "",
    typeBankAccount: "",
    accountNumber: "",
    parent: false,
  },
  setState,
  errorField,
}) {
  const [newBankAccount, setNewBankAccount] = useState([]);

  const handleChange = (e) => {
    if (e.target.name === "accountNumber") {
      const sanitizedValue = sanitizarInputNumerico(e.target.value);
      e.target.value = sanitizedValue;
    }
    const { name, value } = e.target;
    setState({ ..._state, [name]: value });
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    setState({ ..._state, [name]: value });
  };

  useEffect(() => {}, [errorField]);

  useEffect(() => {
    setNewBankAccount(bankAccountOptions.filter((b) => b.value !== 9));
  }, []);

  return (
    <form action="#" method="POST">
      <div className="mt-3">
        <div>
          <div className="mt-4">
            {bankAccountOptions && (
              <div>
                <FilterableSelect
                  options={newBankAccount.map((banck) => ({
                    label: banck.label,
                    value: banck.value,
                    icon: banck.icon,
                  }))}
                  label={"Banco"}
                  value={_state.bankAccount}
                  onChange={handleChangeSelect}
                  name="bankAccount"
                  placeholder="Selecciona tu banco"
                  error={errorField.bankAccount}
                  required
                />
              </div>
            )}
            {errorField.bankAccount && (
              <span
                className="text-sm"
                style={{ color: "#fc3e58", fontStyle: "italic", paddingTop: 0 }}
              >
                {errorField.bankAccount}
              </span>
            )}
          </div>
          <div className=" mt-4">
            {typeBankAccountOptions && (
              <div>
                <FilterableSelect
                  options={typeBankAccountOptions.map((type) => ({
                    label: type.label,
                    value: type.value,
                  }))}
                  label={"Tipo de cuenta"}
                  value={_state.typeBankAccount}
                  onChange={handleChangeSelect}
                  name="typeBankAccount"
                  placeholder="Selecciona el tipo de cuenta"
                  error={errorField.typeBankAccount}
                  required
                />
              </div>
            )}
            {errorField.typeBankAccount && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  textAlign: "left",
                  paddingTop: 0,
                }}
              >
                {errorField.typeBankAccount}
              </span>
            )}
          </div>

          <div className="mt-4">
            <div>
              <StepInput
                name="accountNumber"
                value={_state.accountNumber}
                label={"Número de cuenta"}
                onChange={handleChange}
                error={errorField.accountNumber}
                required
                placeholder="49000000564"
                autoFocus={true}
                type="number"
              />
            </div>

            {errorField.accountNumber && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  paddingBottom: 0,
                }}
              >
                {errorField.accountNumber ?? ""}
              </span>
            )}
          </div>
        </div>
      </div>
    </form>
  );
}
